module.exports = __webpack_public_path__ + "media/event_background_video.95ebb383.mp4";